let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ajByh")).then(() => parcelRequire('kz89i'));